import { NavLink } from 'react-router-dom';

const TenantSidebar = () => (
  <nav className="sidebar" aria-label="Tenant navigation">
    <div className="sidebar-section" aria-hidden="true">Tenant</div>
    <NavLink to="/tenant/dashboard" className={({ isActive }) => `sidebar-item${isActive ? ' active' : ''}`}><span aria-hidden="true">🏠</span> Dashboard</NavLink>
    <NavLink to="/tenant/billing" className={({ isActive }) => `sidebar-item${isActive ? ' active' : ''}`}><span aria-hidden="true">💳</span> Billing &amp; Payments</NavLink>
    <NavLink to="/tenant/plan" className={({ isActive }) => `sidebar-item${isActive ? ' active' : ''}`}><span aria-hidden="true">📡</span> My Plan</NavLink>
    <NavLink to="/tenant/support" className={({ isActive }) => `sidebar-item${isActive ? ' active' : ''}`}><span aria-hidden="true">🎫</span> Support</NavLink>
    <NavLink to="/tenant/settings" className={({ isActive }) => `sidebar-item${isActive ? ' active' : ''}`}><span aria-hidden="true">⚙️</span> Account Settings</NavLink>
  </nav>
);

export default TenantSidebar;
